// src/pages/SsoCallback.jsx
// A donde api_vicsa redirige tras validar el login con Microsoft (dominio
// permitido, cuenta activa, acceso a "helpdesk" otorgado). Trae la
// constancia firmada en ?assertion=, o un ?error= si algo se rechazo antes.
import React, { useEffect, useRef, useState } from 'react';
import { useSearchParams, Link } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';

const MENSAJES_ERROR = {
  dominio_no_permitido: 'Tu correo no pertenece a un dominio autorizado para iniciar sesión aquí.',
  desvinculado: 'Tu cuenta está desvinculada. Contacta al administrador del sistema.',
  sin_acceso: 'Tu cuenta no tiene acceso otorgado a HelpDesk todavía. Contacta al administrador del sistema.',
};

export default function SsoCallback() {
  const [searchParams] = useSearchParams();
  const { loginWithAssertion } = useAuth();
  const [error, setError] = useState('');
  const intentado = useRef(false);

  useEffect(() => {
    if (intentado.current) return;
    intentado.current = true;

    const errorParam = searchParams.get('error');
    if (errorParam) {
      setError(MENSAJES_ERROR[errorParam] || 'No se pudo iniciar sesión con Microsoft.');
      return;
    }

    const assertion = searchParams.get('assertion');
    if (!assertion) {
      setError('No se recibió la constancia de login. Intenta de nuevo.');
      return;
    }

    loginWithAssertion(assertion).catch((err) => {
      setError(err.message || 'No se pudo completar el inicio de sesión.');
    });
  }, [searchParams, loginWithAssertion]);

  return (
    <div className="min-h-screen flex items-center justify-center bg-gradient-to-br from-blue-100 via-white to-blue-200 dark:from-gray-900 dark:via-gray-900 dark:to-gray-800">
      <div className="w-full max-w-md p-6 rounded-2xl shadow-2xl bg-white/90 dark:bg-gray-900/90 backdrop-blur-md text-center">
        {error ? (
          <>
            <h2 className="text-xl font-semibold text-red-600 dark:text-red-400 mb-2">No se pudo iniciar sesión</h2>
            <p className="text-gray-600 dark:text-gray-400 mb-4">{error}</p>
            <Link to="/login" className="text-blue-600 dark:text-blue-400 hover:underline">
              Volver al inicio de sesión
            </Link>
          </>
        ) : (
          <>
            <div className="w-12 h-12 border-4 border-blue-600 border-t-transparent rounded-full animate-spin mx-auto mb-4" />
            <h2 className="text-xl font-semibold text-gray-900 dark:text-white">Completando inicio de sesión...</h2>
          </>
        )}
      </div>
    </div>
  );
}
